import { render, staticRenderFns } from "./FutureOrderList.vue?vue&type=template&id=c61c1052&"
import script from "./FutureOrderList.vue?vue&type=script&lang=js&"
export * from "./FutureOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports